module.exports = __webpack_public_path__ + "static/media/HIW_steps_3.3c2e6d63.jpg";